import { Remote } from '@okapi/remote';
import React from 'react';
import { useStoreContext } from 'store';

export const RecommendationsBrands = () => {
  const { model } = useStoreContext();

  const brands = model?.data?.BrandsCarousel;

  if (!brands?.placementId) return null;

  return (
    <Remote
      id="catalogue-brands"
      widget="placements/brands"
      data={{
        pageType: 'categoryPlacements',
        requestData: { placementId: brands.placementId, categoryId: '1' },
        analytics: {
          elementBlock: 'catalogLvl0',
          elementName: 'toCatalogLvl0',
        },
      }}
    />
  );
};
